import React, { useEffect } from 'react';

const testimonials = [
  {
    name: 'Sudip Lingthep',
    position: 'CEO, HigherTrekking',
    image: '/img/client-1.jpg',
    content: `"Aman delivered exactly what we needed — a clean, fast website that helped us launch our product on time. His communication was excellent and he even suggested improvements we hadn’t thought of."`
  },
  {
    name: 'Sunil Mahla',
    position: 'Chief Marketing Officer, LehGo.in',
    image: '/img/client-2.jpg',
    content: `"Aman isn't just a developer — he's a strategic partner. From SEO to web performance, he helped optimize our entire digital presence. Highly recommended for any business looking to grow online."`
  },
  {
    name: 'kolanu Anirudh Reddy',
    position: 'Product Manager, Startup Studio',
    image: '/img/client-3.jpg',
    content: `"Our Shopify store went from clunky to high-converting thanks to Aman. He handled everything from design tweaks to backend fixes. We saw a 30% boost in sales within the first month."`
  }
];

const Testimonial = () => {
  useEffect(() => {
    const swiper = new window.Swiper('.swiper-container', {
		autoplay: {
			delay: 5000,
		},
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,
		effect: "creative",
		creativeEffect: {
		prev: {
			shadow: true,
			translate: ["-120%", 0, -500],
		},
		next: {
			shadow: true,
			translate: ["120%", 0, -500],
		},
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: "fraction",
		},
		on: {
			slideChangeTransitionStart: function () {
				document.querySelectorAll('.testimonial-thumb img').forEach(img => {
				img.classList.remove('animated', 'zoomIn');
				img.style.opacity = '0';
				});
			},
			slideChangeTransitionEnd: function () {
				document.querySelectorAll('.testimonial-thumb img').forEach(img => {
				img.classList.add('animated', 'zoomIn');
				img.style.opacity = '1';
				});
			}
		}
    });
  }, []);

  return (
    <div className="container">
      <div className="row testimonials justify-content-center">
        <div className="col-12 col-md-10 col-lg-7">
          <div className="swiper-container slider-min items">
            <div className="swiper-wrapper">
              {testimonials.map((testimonial, index) => (
                <div className="swiper-slide item" key={index}>
                  <div className="testimonial text-center border rounded-5 p-4 p-md-0">
                    <div className="testimonial-meta">
                      <div className="testimonial-thumb">
                        <img className="rounded-circle" src={testimonial.image} alt={testimonial.name} />
                      </div>
                      <h5 className="client-name mt-3 mb-1">{testimonial.name}</h5>
                      <span className="client-position">{testimonial.position}</span>
                    </div>
                    <div className="testimonial-content mt-4">
                      <p>{testimonial.content}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;